<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>


<div class="container">
<div class="row justify-content-center">
<div class="col-xl-8 col-lg-11 col-md-12 p-3 p-md-5">
<div class="hero__caption text-center">
    <a routerLink="/"><img class="img-fluid" src="assets/img/logo.png" alt="pembuatan website sekolah"/></a>
    <h2><strong><a class="text-primary" href="https://axcoraschool.vercel.app">Website sekolah</a></strong></h2>
    <img class="img-fluid" alt="aplikasi sekolah online" src="assets/img/aplikasisekolah online web app (6).jpg"/>
    <p class="text-secondary">Axcora school app technology solusi terbaik dalam kebutuhan layanan dan jasa pembuatan website sekolah edukasi.</p>
  
</div>
</div>
</div>
</div> 

    
    <div class="about-area2 section-padding40 section-bg2" 
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
  background-attachment: fixed;
background-position: center; 
background-size: cover;
"
>
    <div class="container">
    <div class="row align-items-center">
    <div class="col-xl-5 col-lg-6 col-md-12 p-3">
    <div class="about-caption mb-50">
    <div class="about-icon text-center text-white">
        <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
            <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
          </svg>
    </div>
    
    <div class="section-tittle mb-25">
  <p class="display-4 text-light">Intro</p>
    </div>
    <p class="mb-20 text-white">
        Pada setiap kebutuhan untuk website terutama edukasi wajib dan harus memberikan informasi yang detail sekaligus memiliki area khusus siswa yang memudahkan siswa dalam cek laporan absensi, keuangan, dan rapot nilai sekolah . Hal ini agar privasi siswa terjaga semakin nyaman dalam penggunaan online system . Dan juga tentunya memiliki fitur login admin untuk melakukan update.
    </p>
    </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
    
    <div class="about-img ">
    <img class="img-fluid rounded shadow" src="assets/img/aplikasisekolah online web app (15).jpg" alt="website sekolah lengkap"/>
    </div>
    </div>
    </div>
    </div>
    </div>
    
    
    <div class="about-area2 pb-bottom">
    <div class="container">
    <div class="row align-items-center">
    <div class="col-xl-6 col-lg-5 col-md-9 p-3">
    
    <div class="about-img ">
    <img src="assets/img/cmssekolah.png" alt="website informasi sekolah"/>
    </div>
    </div>
    <div class="col-xl-5 col-lg-6 col-md-12 p-3">
    <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
              </svg>
    </div>
    
    <div class="section-tittle mb-25">
    <p class="display-4">Info</p>
    </div>
    <p class="mb-20">
Dan informasi lengkap serta detail wajib di tampilkan agar pengunjung website dapat melihat apa saja informasi , kemudian fasilitas yang tersedia, prestasi dan penghargaan yang diraih , kurikulum , sejarah, visi misi dan masih banyak info yang wajib di tampilkan pada display.
    </p>
   </div>
    </div>
    </div>
    </div>
    </div>

    
          <div class="container">
    <div class="row">
        <div class="col-6 col-md-6 p-3 p-md-5">
        <img class="img-fluid" alt="website sekolah murah" src="assets/img/aplikasisekolah online web app (3).png"/>
<h3>Developer</h3>
<p>
    Team developer kami memiliki area khusus nya pada halaman utama untuk kebutuhan desain dan melakukan link ke web area lain nya,agar struktur info yang didapat semakin akurat dan detail.
</p>
    </div>
    <div class="col-6 col-md-6 p-3 p-md-5">
        <img class="img-fluid" alt="website sekolah murah" src="assets/img/aplikasisekolah online web app (4).png"/>
<h3>Web Admin</h3>
<p>
    Selanjutnya team dari web admin anda melakukan input data dalam kebutuhan akan informasi mengenai update dan kebutuhan lain nya, terintegrasi dengan halaman awal utama page.
</p>
    </div>
    </div>
    </div>
       
    <div class="about-area2 section-padding40 section-bg2" 
    style="background-image: url('assets/img/h1_hero.png');
    background-repeat: no-repeat;
      background-attachment: fixed;
    background-position: center; 
    background-size: cover;
    "
    >
        <div class="container">
        <div class="row align-items-center">
            <div class="col-xl-6 col-lg-6 col-md-9 col-sm-9">
        
                <div class="about-img ">
                <img class="img-fluid rounded shadow" src="assets/img/aplikasisekolah online web app (10).jpg" alt="website sekolah lengkap"/>
                </div>
                </div>
        <div class="col-xl-5 col-lg-6 col-md-12 p-3">
        <div class="about-caption mb-50">
        <div class="about-icon text-center text-white">
            <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" fill="currentColor" class="bi bi-award" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M9.669.864L8 0 6.331.864l-1.858.282-.842 1.68-1.337 1.32L2.6 6l-.306 1.854 1.337 1.32.842 1.68 1.858.282L8 12l1.669-.864 1.858-.282.842-1.68 1.337-1.32L13.4 6l.306-1.854-1.337-1.32-.842-1.68L9.669.864zm1.196 1.193l-1.51-.229L8 1.126l-1.355.702-1.51.229-.684 1.365-1.086 1.072L3.614 6l-.25 1.506 1.087 1.072.684 1.365 1.51.229L8 10.874l1.356-.702 1.509-.229.684-1.365 1.086-1.072L12.387 6l.248-1.506-1.086-1.072-.684-1.365z"/>
                <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"/>
              </svg>
        </div>
        
        <div class="section-tittle mb-25">
      <p class="display-4 text-light">Skema</p>
        </div>
        <p class="mb-20 text-white">
         Penerapan desain dengan skema konsep agar memudahkan pengunjung dan siswa hingga ornag tua wali murid dalam kebutuhan untuk meperoleh informasi yang dibutuhkan , dengan menggunakan konsep landing page halaman awal dengan technology framework CMF untuk alasan keamanan yang lebih kuat dan powerfull serta elegan nya homepage pada display tampilan.Serta CMS untuk web admin.
        </p>
        </div>
        </div>
        <div class="col-12 col-md-12 p-3 p-md-5 text-white">
            <h3><strong><a href="https://axcoraschool.vercel.app" class="text-light">Website Sekolah Info</a></strong></h3>
            <p class="text-light">Fitur informasi : Sejarah sekolah
, Visi Misi
, Kepala sekolah
, Profile guru
, Kurikulum sekolah
, PPDB Sekolah - tata cara dan persyaratan
, Fasilitas sekolah
, Daftar Siswa per kelas
, Mata pelajaran per kelas
, List Wakil kelas
, OSIS dan pembina
, Ekstra Kurikuler
, Prestasi sekolah akademik dan non akademik
, Sosial Media Youtube facebook instagram dll
, No rekening sekolah untuk pembayaran online
, Alamat lengkap sekolah
, Kontak phone sekolah
, WhatsApp khusus sekolah
, Gmail kami daftarkan sesuai nama sekolah
, File Foto dan video sekolah
, Form dan file lain nya </p>
<hr class="bg-white"/>
    <h3><strong><a href="https://axcoraschool.vercel.app" class="text-light">Aplikasi Sekolah</a></strong></h3>
<p class="text-white">
Dan sebagai penunjang maka aplikasi sekolah kami siap digunakan dalam berbagai keperluan sesuai dengan paket website sekolah dalam kebutuhan nya, dengan dukungan aplikasi ini memudahkan dalam kebutuhan full web app bekerja , website sebagai media informasi, dan aplikasi untuk kebutuhan membantu pekerjaan hingga proses belajar mengajar. tersedia aplikasi absensi siswa untuk kebutuhan monitoring absensi siswa, nilai dan tugas online, pembayaran dan keuangan sekolah hingga aplikasi lain nya bisa anda dapat kan sesuai dengan paket yang tersedia.
</p>
        </div>
       </div>
        </div>
        </div>

<div class="container-fluid">
    <div class="row">
        <div clas="col-12 col-md-12 p-3 p-md-5">
            <div class="p-3 p-md-5">
            <p class="display-4">
                Technology Dev.
            </p>
            <p>
Dalam penerapan dan pengembangan project <a href="https://axcoraschool.vercel.app" class="text-dark">pembuatan website sekolah</a> kami menggunakan berbagai technology dan anda dapat memilih technology sesuai kebutuhan anda disini, dynamis website dengan kebutuhan penggunaan database dalam kebutuhan develope nya, dan generator static site era website modern dengan technology web app modern dengan kecepatan dan powerfull nya dalam develope nya. dan apapun technology yang di gunakan kami pastikan untuk memberikan informasi yang detail dan lengkap hingga kebutuhan akan integrasi dengan applikasi sekolah dalam satu web apps.
            </p>
        </div>
        </div>
        <div class="col-12 col-md-4 p-3 p-md-5">
        <img class="img-fluid" alt="website technology" src="assets/img/aplikasisekolahapps.png"/>
        </div>
        <div class="col-12 col-md-8 p-3 p-md-5">
                <p><strong>Dynamis Website</strong>
    Develope pada halaman utama kami menggunakan MODX revolutions untuk kebutuhan SEO dan powerfull nya technology digunakan, dan dapat juga menggunakan <a href="https://laravel.com" target="_blank" class="text-dark">laravel</a> php artisan untuk kebutuhan modern technology, selanjut nya pada halaman admin tersedia cms open source kami get axcora cms,maupun axcora school cms, dan alternatif dapat menggunakan <a href="https://wordpress.org" class="text-dark" target="_blank">wordpress</a> dalam kebutuhan untuk admin update data, hosting digital ocean dan google clouds untuk kestabilan nya, dan tentu applikasi sekolah sudah include dalam satu domain .sch.id.
                </p>
                <p><strong>Modern Website</strong>
                    Solusi terbaik dan modern untuk kebutuhan website sekolah terbaru dan modern dengan mengembangkan membangun project menggunakan <a href="https://angular.io" target="_blank" class="text-dark">angular</a> , atau <a href="https://gatsbyjs.org" target="_blank" class="text-dark">gatsby JS</a> dan jekyll dalam kebutuhan single page application biasa disebut dengan progresive web app, technology ini memungkinkan pengunjung akses page anda tanpa loading sama sekali, dan karena develope nya menggunakan host khusus seperti firebase, vercel maka untuk kebutuhan aplikasi kami akan menggunakan dua domain sekolah dalam penerpaan nya, satu khusus website informasi dan satu khsusus untuk halaman applikasi .
                                </p>
            </div>
            <div class="col-12 col-md-12 p-3 p-md-5">
              <p>Dengan bermacam technology maupun cms yang digunakan akan menyempurnakan dalam develope nya, dengan struktur yang tertata rapi akan semakin memudahkan dalam kebutuhan dan kelengkapan informasi maupun aplikasi untuk digunakan.</p>
            </div>
       </div>
</div>

    <div class="about-area2 section-padding40 section-bg2" 
style="background-image: url('assets/img/h1_hero.png');
background-repeat: no-repeat;
  background-attachment: fixed;
background-position: center; 
background-size: cover;
"
>
    <div class="container">
    <div class="row align-items-center">
    <div class="col-12 col-md-4 p-3">
    <div class="about-caption mb-50">
   
 <p class="display-4 text-light">Price</p>
    <p class="mb-20 text-white">
      Pilih paket sesuai kebutuhan anda.
    </p>
    </div>
    </div>
    <div class="col-12 col-md-4 p-3 text-center">
    <div class="shadow rounded bg-white p-3 p-md-3">
        <div class="card-top bg-primary text-white rounded text-center p-3">
        <span>Dynamis</span>
        <h4 class="text-white"><strong>Rp.5.652.600</strong></h4>
        <span>per tahun</span>
    </div>
    <div class="p-3 p-md-5">
        <ul>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Domain sch.id + Hosting </li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> website + Input Data</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Dynamic website<br/><small>Laravel , Symfony,  MODX , Wordpress, get Axcora CMS , axcora school CMS</small></li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Aplikasi Absensi Online</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Aplikasi Rapot Online</li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Aplikasi E-Learning <br/><small>Free version</small></li>
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Cloudflare LetsEncrypt</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Litespeed web server</li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> 8GB Web Space</li>     
            <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                </svg> Layanan support</li>
             </ul>
            <br/>
            <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3Adynamiswebschool%0APrice%20%3ARp.5.652.600/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Get Started</a>
        </div>
    </div>
    </div>
    <div class="col-12 col-md-4 p-3 text-center">
        <div class="shadow rounded bg-white p-3 p-md-3">
            <div class="card-top bg-danger text-white rounded text-center p-3">
            <span>Modern</span>
            <h4 class="text-white"><strong>Rp.6.652.600</strong></h4>
            <span>per tahun</span>
        </div>
        <div class="p-3 p-md-5">
            <ul>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> 2 Domain sch.id <br/><small>Static & Dynamic Apps</small></li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Firebase / Vercel Host</li>    
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> website + Input Data</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Modern website<br/><small>Angular / Gatsby JS / Jekyll</small></li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Dynamic website<br/><small>Laravel , Symfony,  MODX , Wordpress, get Axcora CMS , axcora school CMS</small></li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Aplikasi Absensi Online</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Aplikasi Rapot Online</li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Aplikasi E-Learning <br/><small>Free version</small></li>
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Cloudflare LetsEncrypt</li>
                    <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                        </svg> Litespeed web server</li>
                        <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                            </svg> 8GB Web Space</li>     
                <li><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-check-circle text-success" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path fill-rule="evenodd" d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z" />
                    </svg> Layanan support</li>
                 </ul>
                <br/>
                <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3Amodernwebschool%0APrice%20%3ARp.6.652.600/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Get Started</a>
            </div>
        </div>
        </div>
    </div>
    </div>
    </div>
    

    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/axcoraschool" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
